export default __webpack_public_path__ + "2ddc50f70cb1536656a90939ef3b02a3.png";